module.exports = __webpack_public_path__ + "img/01_Tierpfleger_Foto.88ba8609.jpg";